import React, { useState } from "react";

import Layout3Icon from "@assets/puck/layout_3.svg";
import Layout21Icon from "@assets/puck/layout_2_1.svg";
import Layout12Icon from "@assets/puck/layout_1_2.svg";
import Layout111Icon from "@assets/puck/layout_1_1_1.svg";

const LayoutSelector = ({ onChange, value }) => {
  const [layout, setLayout] = useState(value);

  const handleLayoutChange = (value) => {
    setLayout(value);
    onChange(value);
  };

  const layoutOptions = [
    {
      value: "oneThirdTwoThirds",
      preview: (
        <div
          className="flex items-center justify-center"
          style={{ gap: "4px" }}
        >
          <div className="flex items-center justify-center rounded border">
            <Layout12Icon width="25px" height="25px" />
          </div>
        </div>
      ),
    },
    {
      value: "twoThirdsOneThird",
      preview: (
        <div
          className="flex items-center justify-center"
          style={{ gap: "4px" }}
        >
          <div className="flex items-center justify-center rounded border">
            <Layout21Icon width="25px" height="25px" />
          </div>
        </div>
      ),
    },
    {
      value: "threeEqual",
      preview: (
        <div
          className="flex items-center justify-center"
          style={{ gap: "4px" }}
        >
          <div className="flex items-center justify-center rounded border">
            <Layout111Icon width="25px" height="25px" />
          </div>
        </div>
      ),
    },
    {
      value: "onlyOne",
      preview: (
        <div
          className="flex items-center justify-center"
          style={{ gap: "4px" }}
        >
          <div className="flex items-center justify-center rounded border">
            <Layout3Icon width="25px" height="25px" />
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="mb-2">
      <div className="w-full fs-6 font-bold mb-2">Layout</div>
      <div className="flex" style={{ gap: "12px" }}>
        {layoutOptions.map((option) => (
          <div
            key={option.value}
            role="button"
            onClick={() => handleLayoutChange(option.value)}
            className={`p-2 border rounded`}
            style={{
              borderWidth: layout === option.value ? "3px" : "1px",
              borderColor: layout === option.value ? "#0066cc" : "#dee2e6",
              backgroundColor:
                layout === option.value
                  ? "rgba(0, 102, 204, 0.08)"
                  : "transparent",
              boxShadow:
                layout === option.value
                  ? "0 2px 8px rgba(0, 102, 204, 0.2)"
                  : "none",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              if (layout !== option.value) {
                e.currentTarget.style.borderColor = "#6c757d";
              }
            }}
            onMouseLeave={(e) => {
              if (layout !== option.value) {
                e.currentTarget.style.borderColor = "#dee2e6";
              }
            }}
          >
            {option.preview}
            {option.label && (
              <div className="text-center mt-1 fs-7 text-muted">
                {option.label}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LayoutSelector;
